import React from "react";
import { connect } from "dva";
import { component_tool, framework_tool } from '@/tool';
import { reduxTemplateConfig, templateConfig } from './config';
import Item from "antd/lib/list/Item";
let { WizNotice, WizBrowserExport } = component_tool;
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;

class Index extends WizContainer {
  componentName = 'UserActionLogInfo';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _componentDidMount() {
    this.doAction({
      path: "authUserLog/typeList",
      payload: {
        key: "typeList",
        apiParams: {}
      }
    });
  }

  propsAndStateOnChange = {
    typeList: this._typeList.bind(this),
  }

  _typeList(nextProps, nextState) {
    let { success, data, msg } = nextProps?.typeList
    if (success) {
      let arr = data
      arr.forEach(item => {
        item.label = item.title
        item.children?.length > 0 && item.children.forEach(cItem => {
          cItem.label = cItem.title
          cItem.children = null
        })
      })
      nextState.typeData = arr

      return true
    } else {
      wizNotice.error(msg);
    }
    return !!success;
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }



  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '会话标识',
        field: 'linkTraceId',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
          font: {}
        },
      },
      {
        headerName: '操作人',
        field: 'fullName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '操作类型',
        field: 'operateType',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '业务类型',
        field: 'operateBizType',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '业务名称',
        field: 'operateBizName',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '请求状态',
        field: 'status',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
        },
      },
      {
        headerName: '请求时间',
        field: 'createTime',
        width: 35,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        let elements = '';
        d.menuElements && d.menuElements.forEach(e => {
          elements += e.name + ',';
        })
        elements = elements.substring(0, elements.length - 1);
        _d.elements = elements;
        _data.push(_d)
      });


      WizBrowserExport({
        title: '用户行为日志',
        sheetName: '用户行为日志',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '用户行为日志.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let { typeData } = this.state
    let _templateConfig = templateConfig({ typeData: typeData })
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        changeDisable: this._handleCMD,
        export: this._handleFile
      },
    });
    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { authUserLog } = state;
  const typeList = modelUtils.getModelEntity(authUserLog, 'typeList');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'authUserLog')
  return {
    typeList,
    ...load
  }
};

export default connect(mapStateToProps)(Index);

